import GoogleAnalytics from '@/components/GoogleAnalytics'
import Layout from '@/components/Layout'
import ThemeStyles from '@/components/ThemeStyles'
import client from '@/utilities/apolloClient'
import { ApolloProvider } from '@apollo/client'
import { FaustProvider } from '@faustwp/core'
import type { AppProps } from 'next/app'
import { Instrument_Sans, Poppins } from 'next/font/google'
import { useRouter } from 'next/router'
import 'aos/dist/aos.css'
import 'normalize.css/normalize.css'
import { useEffect } from 'react'
import '../faust.config'
import '../styles/main.scss'

const poppins = Poppins({
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700'],
  style: ['normal', 'italic'],
  display: 'swap',
  variable: '--font-poppins'
})

const instrumentSans = Instrument_Sans({
  subsets: ['latin'],
  weight: 'variable',
  style: ['normal', 'italic'],
  display: 'swap',
  variable: '--font-instrument-sans'
})

export default function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter()
  useEffect(() => {
    import('aos').then((AOS) => {
      AOS.default.init({
        duration: 1200,
        once: true
      })
    })
  }, [])

  return (
    <div className={`${poppins.variable} ${instrumentSans.variable}`}>
      <GoogleAnalytics />
      <ThemeStyles />
      <FaustProvider pageProps={pageProps}>
        <ApolloProvider client={client}>
          <Layout siteData={pageProps.__siteData}>
            <Component {...pageProps} key={router.asPath} />
          </Layout>
        </ApolloProvider>
      </FaustProvider>
    </div>
  )
}
